import { styled } from '@creditas/stylitas'

export const WizardStyle = styled.div`
  height: 50px;
  min-width: 1px;
  padding: 0 24px 10px;
`
